<template>
  <div
    :class="buttonGroupClass"
    ds-component="DsButtonGroup"
  >
    <div
      v-if="!isMultiple"
      :class="singleButtonClass"
      @click="changeSingleButton(label)"
    >
      <DsIcon
        v-if="label.startsWith('icon:')"
        :name="normalizedIconLabel(label)"
        size="small"
      />
      <span v-else>{{ label }}</span>
    </div>

    <div
      v-else
      class="ds-button-group__multiple"
    >
      <div
        v-for="(label, index) in buttons"
        :key="index"
        :class="multipleButtonClass(index)"
        @click="activeMultipleButton(index)"
      >
        <DsIcon
          v-if="label.startsWith('icon:')"
          size="small"
          :name="normalizedIconLabel(label)"
        />
        <span v-else>{{ label }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck

import Vue from 'vue';
import { DsIcon } from '@ds/icons';

export default Vue.extend({
  name: 'DsButtonGroup',
  components: {
    DsIcon
  },
  data() {
    return {
      buttons: [],
      activatedIndex: 0,
      singleButtonValue: true,
    };
  },
  props: {
    values: {
      type: [Array, String],
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.buttons = typeof this.values === 'string'
      ? [this.values]
      : this.values;
  },
  computed: {
    isMultiple() {
      return this.buttons.length > 1;
    },
    label() {
      return this.buttons[this.activatedIndex];
    },
    buttonGroupClass() {
      return {
        'ds-button-group': true,
        'ds-button-group--dense': this.dense,
        'ds-button-group--multiple': this.isMultiple,
      };
    },
    singleButtonClass() {
      return {
        'ds-button-group__button': true,
        'ds-button-group__button--deactivated': !this.singleButtonValue,
      };
    },
  },
  methods: {
    activeMultipleButton(index) {
      this.activatedIndex = index;
      this.$emit('change', {
        index,
        label: this.label,
      });
    },
    normalizedIconLabel(label) {
      return label.replace('icon:', '');
    },
    multipleButtonClass(index) {
      return {
        'ds-button-group__multiple-button': true,
        'ds-button-group__multiple-button--activated': this.activatedIndex === index,
      }
    },
    changeSingleButton(label) {
      this.singleButtonValue = !this.singleButtonValue;
      this.$emit('change', {
        label,
        value: this.singleButtonValue,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/ButtonGroup.scss';
</style>
